import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { FilterStatuses } from '../../../../components/Filters'
import { ordersSelector } from '../../../../redux/selectors/orders';

const Statuses = () => {
  const {
    statuses,
  } = useSelector((state) => ordersSelector(state));

  return (
    <FilterStatuses
      statuses={statuses}
    />
  )
}

export default memo(Statuses);
